import * as React from 'react';
import { connect, Dispatch } from "react-redux";
import { withRouter } from 'react-router-dom';
import { RouteComponentProps } from "react-router"
import { Modal } from "react-bootstrap";
import * as _ from "lodash";

import {
    IApplicationState, AppActionCreators,
    IEmailFamilyState, EmailFamilyActionCreators,
    IEmailModelState, EmailModelActionCreators,
    IEmailTemplateState, EmailTemplateActionCreators, IAddEmailTagResponse, IDeleteEmailTagResponse, IDeleteSendeeResponse
} from "../../store";

import {
    IEmailTemplate, IEmail,
    IEmailTemplateResponse, IEmailFamilyListResponse, IEmailModelListResponse, IEmailSendeeListResponse, IEmailEngineVariableKeysResponse, IEmailModelTemplateVariablesResponse, IEmailSendeeResponse, IEmailAddressField, IContactEntityType
} from '../../models';
import { AxiosError } from 'axios';

interface IRouterProps {
    id: string
}

interface IOwnProps extends RouteComponentProps<IRouterProps> { }

interface IEmailTemplateEditStateProps {
    emailFamilies: IEmailFamilyState;
    emailTemplates: IEmailTemplateState;
    emailModels: IEmailModelState;
    styleVariableKeys: string[];
    modelVariables: string[];
    sendeeList: {
        emailAddressFields: IEmailAddressField[],
        contactEntityTypes: IContactEntityType[]
    },
    emailTags: IEmail[];
}

interface IEmailTemplateDispatchProps {
    showLoading: (message?: string) => Promise<void>,
    hideLoading: () => void,
    getEmailTemplate: (templateId: number) => Promise<IEmailTemplateResponse>,
    getEmailModelTemplateVariables: (emailModelId: number) => Promise<IEmailModelTemplateVariablesResponse>,
    getEmailEngineVariableKeys: () => Promise<IEmailEngineVariableKeysResponse>,
    getEmailModel: () => Promise<IEmailModelListResponse>,
    getSendeeList: () => Promise<IEmailSendeeListResponse>,
    getEmailFamilyList: () => Promise<IEmailFamilyListResponse>,
    addSendee: (emailTemplateId: number, emailAddressFieldId: number, centerTypeId: number, contactEntityTypeId: number, contactPositionId: number) => Promise<IEmailSendeeResponse>,
    deleteSendee: (emailSendeeId: number) => Promise<IDeleteSendeeResponse>,
    addEmailTag: (emailTemplateId: number, emailFamilyId: number, emailTypeId: number, emailExcelId: number) => Promise<IAddEmailTagResponse>,
    deleteEmailTag: (emailId: number) => Promise<IDeleteEmailTagResponse>,
    saveEmailTemplate: (emailTemplateId: number, emailModelId: number, subject: string, body: string, sendToEntity: boolean) => Promise<any>
}

type TEmailTemplateEditProps =
    IOwnProps
    & IEmailTemplateEditStateProps
    & IEmailTemplateDispatchProps;

interface IState {
    subject: string,
    body: string,
    sendToEntity: boolean,
    selectedEmailModelId: number,
    selectedEmailTemplate: IEmailTemplate,

    selectedEmailFamilyId: number,
    selectedEmailTypeId: number,
    selectedEmailExcelId: number,

    selectedEmailAddressFieldId: number,
    selectedContactEntityTypeId: number,
    selectedCenterTypeId: number,
    selectedContactPositionId: number,

    showAddSendeeWarning: boolean,
    message: {
        show: boolean,
        text: string,
        type: string
    }
}

class EmailTemplateEdit extends React.Component<TEmailTemplateEditProps, IState>{
    constructor(props: TEmailTemplateEditProps) {
        super(props);

        var dummyEmailTemplate: IEmailTemplate = {
            subject: '',
            body: '',
            senderContactId: -1,
            sendToEntity: false,
            id: -1,
            emailModel: -1,
            emailSendees: [],
            emailTags: [],
        };

        this.state = {
            subject: '',
            body: '',
            sendToEntity: false,
            selectedEmailModelId: 0,
            selectedEmailTemplate: dummyEmailTemplate,

            selectedEmailTypeId: -1,
            selectedEmailFamilyId: -1,
            selectedEmailExcelId: -1,

            selectedEmailAddressFieldId: 0,
            selectedContactEntityTypeId: 0,
            selectedCenterTypeId: 0,
            selectedContactPositionId: 0,

            showAddSendeeWarning: false,
            message: {
                show: false,
                text: "",
                type: ""
            }
        };
    }

    componentDidMount() {
        this.getData();
    }

    public getData = () => {
        var templateId = this.props.match.params.id != null ? parseInt(this.props.match.params.id) : 0;

        this.props.showLoading("Getting data...").then(() => {
            Promise.all([
                this.props.getEmailTemplate(templateId),
                this.props.getEmailEngineVariableKeys(),
                this.props.getSendeeList(),
                this.props.getEmailModel(),
                this.props.getEmailFamilyList()
            ]).then((response: [
                IEmailTemplateResponse,
                IEmailEngineVariableKeysResponse,
                IEmailSendeeListResponse,
                IEmailModelListResponse,
                IEmailFamilyListResponse
            ]) => {
                let templateResponse = response[0];

                let { success, results } = templateResponse.data;

                if (success) {
                    this.props.getEmailModelTemplateVariables(results.emailModel).then((templateVariableResponse: IEmailModelTemplateVariablesResponse) => {
                        if (templateVariableResponse.data.success) {
                            this.setState({
                                selectedEmailTemplate: results,
                                subject: results.subject,
                                body: results.body,
                                sendToEntity: results.sendToEntity,
                                selectedEmailModelId: results.emailModel
                            }, () => {
                                this.props.hideLoading();
                            });
                        } else {
                            this.props.hideLoading();
                        }
                    });
                } else {
                    this.props.hideLoading();
                }
            }).catch((error: Error) => {
                this.props.hideLoading();
                console.log(error);
            });
        });
    }

    public emailFamilyChange = (el: React.FormEvent<HTMLSelectElement>) => {
        var selectedEmailFamilyId = parseInt(el.currentTarget.value);
        var selectedEmailFamily = this.props.emailFamilies.list.find(family => family.id == selectedEmailFamilyId);
        var selectedEmailType;
        var selectedEmailTypeId = -1;

        if (selectedEmailFamily != null) {
            if (selectedEmailFamily.emailTypes.length > 0) {
                selectedEmailType = selectedEmailFamily.emailTypes[0];
                selectedEmailTypeId = selectedEmailType.id;
            }
        }

        this.setState({
            selectedEmailFamilyId,
            selectedEmailTypeId
        });
    }

    public emailTypeChange = (el: React.FormEvent<HTMLSelectElement>) => {
        var selectedEmailTypeId = parseInt(el.currentTarget.value);
        var selectedEmailFamily = this.props.emailFamilies.list.find(family => family.id == this.state.selectedEmailFamilyId);
        var selectedEmailType = selectedEmailFamily.emailTypes.find(t => t.id == selectedEmailTypeId);
        var selectedEmailExcelId = -1;

        if (selectedEmailType.emailExcelIds.length > 0)
            selectedEmailExcelId = selectedEmailType.emailExcelIds[0].id;

        this.setState({
            selectedEmailTypeId,
            selectedEmailExcelId
        });
    }

    public emailExcelIdChange = (el: React.FormEvent<HTMLSelectElement>) => {
        var selectedEmailExcelId = parseInt(el.currentTarget.value);

        this.setState({
            selectedEmailExcelId: selectedEmailExcelId
        });
    }

    public emailModelChange = (el: React.FormEvent<HTMLSelectElement>) => {
        var selectedEmailModelId = parseInt(el.currentTarget.value);

        this.props.showLoading("Loading supported model variables...").then(() => {
            this.props.getEmailModelTemplateVariables(selectedEmailModelId)
                .then(() => {
                    this.setState({
                        selectedEmailModelId
                    }, () => {
                        this.props.hideLoading();
                    });
                })
                .catch(() => {
                    this.props.hideLoading();
                });
        });
    }

    //private getMatchingContactEntity = (contactEntityTypeId:number): any => {
    //    if (contactEntityTypeId != null) {
    //        //var contactEntitys = this.state.contactEntityTypes.filter(cet => cet.entityTypeId == contactEntityTypeId);
    //        var contactEntities = this.props.sendeeList.contactEntityTypes.filter(cet => cet.entityTypeId == contactEntityTypeId);

    //        return contactEntities.length > 0 ? contactEntities[0] : null;
    //    }

    //    return null;
    //}

    public emailAddressFieldChange = (el: any) => {
        var selectedEmailAddressFieldId = el.target.value;

        this.setState({
            selectedEmailAddressFieldId
        });
    }

    public contactEntityChange = (el: any) => {
        var selectedContactEntityTypeId = el.target.value;
        var selectedContactEntityType = this.props.sendeeList.contactEntityTypes.find(t => t.entityTypeId == selectedContactEntityTypeId);
        var selectedCenterTypeId = -1;
        var selectedContactPositionId = -1;

        if (selectedContactEntityType.centerTypes.length > 0)
            selectedCenterTypeId = selectedContactEntityType.centerTypes[0].centerTypeId;

        if (selectedContactEntityType.contactPositions.length > 0)
            selectedContactPositionId = selectedContactEntityType.contactPositions[0].contactPositionId;

        this.setState({
            selectedContactEntityTypeId,
            selectedCenterTypeId,
            selectedContactPositionId
        });
    }

    public centerTypeChange = (el: React.FormEvent<HTMLSelectElement>) => {
        var selectedCenterTypeId = parseInt(el.currentTarget.value);

        this.setState({
            selectedCenterTypeId
        });
    }

    public contactPositionChange = (el: React.FormEvent<HTMLSelectElement>) => {
        var selectedContactPositionId = parseInt(el.currentTarget.value);

        this.setState({
            selectedContactPositionId
        });
    }

    public addSendee = () => {
        let { selectedEmailTemplate, selectedEmailAddressFieldId, selectedCenterTypeId, selectedContactEntityTypeId, selectedContactPositionId } = this.state;

        this.props.showLoading("Adding sendee, one moment please...").then(() => {
            this.props.addSendee(selectedEmailTemplate.id, selectedEmailAddressFieldId, selectedCenterTypeId,
                selectedContactEntityTypeId, selectedContactPositionId)
                .then((response: IEmailSendeeResponse) => {
                    let { success, results } = response.data;

                    if (success) {
                        let template = _.cloneDeep(selectedEmailTemplate);

                        template.emailSendees.push(results);

                        this.setState({
                            selectedEmailTemplate: template,
                            selectedEmailAddressFieldId: 0,
                            selectedCenterTypeId: 0,
                            selectedContactEntityTypeId: 0,
                            selectedContactPositionId: 0
                        });
                    }

                    this.props.hideLoading();
                })
                .catch(() => {
                    this.props.hideLoading();
                })
        });
    }

    public deleteSendee = (el: React.FormEvent<HTMLButtonElement>) => {
        var emailSendeeId = parseInt(el.currentTarget.value);

        this.props.showLoading("Deleting sendee, one moment please...").then(() => {
            this.props.deleteSendee(emailSendeeId)
                .then((response: IDeleteSendeeResponse) => {
                    let { success } = response.data;

                    if (success) {
                        let template = _.cloneDeep(this.state.selectedEmailTemplate);

                        template.emailSendees = template.emailSendees.filter(sendee => sendee.id != emailSendeeId);

                        this.setState({
                            selectedEmailTemplate: template
                        });
                    }

                    this.props.hideLoading();
                })
                .catch(() => {
                    this.props.hideLoading();
                });
        });
    }

    public addEmailTag = () => {
        if (this.state.selectedEmailFamilyId == -1 || this.state.selectedEmailTypeId == -1 || this.state.selectedEmailExcelId == -1) {
            this.setState({ showAddSendeeWarning: true });
            return;
        }

        this.props.showLoading("Adding email tag, one moment please...").then(() => {
            let { selectedEmailTemplate, selectedEmailFamilyId, selectedEmailTypeId, selectedEmailExcelId } = this.state;

            this.props.addEmailTag(selectedEmailTemplate.id, selectedEmailFamilyId, selectedEmailTypeId, selectedEmailExcelId)
                .then((response: IAddEmailTagResponse) => {
                    let { success, results } = response.data;

                    if (success) {
                        var template = _.cloneDeep(selectedEmailTemplate);

                        template.emailTags.push(results);

                        this.setState({
                            selectedEmailTemplate: template,
                            selectedEmailFamilyId: 0,
                            selectedEmailTypeId: 0,
                            selectedEmailExcelId: 0
                        });
                    }

                    this.props.hideLoading();
                })
                .catch(() => {
                    this.props.hideLoading();
                });
        });
    }

    public deleteEmailTag = (el: React.FormEvent<HTMLButtonElement>) => {
        var emailTagId = parseInt(el.currentTarget.value);

        this.props.showLoading("Removing email tag, one moment please...").then(() => {
            this.props.deleteEmailTag(emailTagId)
                .then((response: IDeleteEmailTagResponse) => {
                    let { success } = response.data;

                    if (success) {
                        var template = _.cloneDeep(this.state.selectedEmailTemplate);

                        template.emailTags = template.emailTags.filter(tag => tag.id != emailTagId);

                        this.setState({
                            selectedEmailTemplate: template
                        }, () => {
                            this.props.hideLoading();
                        });
                    } else {
                        this.props.hideLoading();
                    }
                })
                .catch(() => {
                    this.props.hideLoading();
                });
        });
    }

    public subjectChange = (el: React.FormEvent<HTMLInputElement>) => {
        this.setState({
            subject: el.currentTarget.value
        });
    }

    public bodyChange = (el: React.FormEvent<HTMLTextAreaElement>) => {
        this.setState({
            body: el.currentTarget.value
        });
    }

    public saveTemplate = (el: React.FormEvent<HTMLButtonElement>) => {
        var preview = el.currentTarget.value == "save-preview";
        var emailTemplate: IEmailTemplate = this.state.selectedEmailTemplate;

        this.props.showLoading("Saving Email Template").then(() => {
            this.props.saveEmailTemplate(emailTemplate.id, this.state.selectedEmailModelId, this.state.subject, this.state.body, this.state.sendToEntity)
                .then((response: IEmailTemplateResponse) => {
                    let { success } = response.data;

                    this.setState({
                        message: {
                            show: true,
                            text: (success ? "Template saved successfully" : "Unable to save template"),
                            type: (success ? "success" : "danger")
                        }
                    }, () => {
                        this.props.hideLoading();

                        if (preview)
                            window.location.href = "/email-template-preview/" + emailTemplate.id;
                    });
                })
                .catch((error: AxiosError) => {
                    this.setState({
                        message: {
                            show: true,
                            text: error.message,
                            type: "danger"
                        }
                    }, () => {
                        this.props.hideLoading();
                    });
                });
        });
    }

    public cancel = () => {
        window.location.href = "/email-engine";
    }

    public sendToEntityChange = (el: React.FormEvent<HTMLInputElement>) => {
        var sendToEntity: boolean = el.currentTarget.checked;

        this.setState({
            sendToEntity
        });
    }

    public entityModalOnHide() {
        //return;
    }

    public hideEntityModel = () => {
        this.setState({
            showAddSendeeWarning: false
        });
    }

    public render() {
        const selectedEmailFamily = this.props.emailFamilies.list.find(f => f.id == this.state.selectedEmailFamilyId);
        const selectedEmailType = selectedEmailFamily != null ? selectedEmailFamily.emailTypes.find(t => t.id == this.state.selectedEmailTypeId) : null;

        const emailTypes = selectedEmailFamily != null ? selectedEmailFamily.emailTypes : [];
        const emailExcelIds = selectedEmailType != null ? selectedEmailType.emailExcelIds : [];

        const selectedContactEntityType = this.props.sendeeList.contactEntityTypes.find(t => t.entityTypeId == this.state.selectedContactEntityTypeId);
        const centerTypes = selectedContactEntityType != null ? selectedContactEntityType.centerTypes : [];
        const contactPositions = selectedContactEntityType != null ? selectedContactEntityType.contactPositions : [];

        return (
            <div className="container">
                {this.state.message.show ?
                    <div className="row">
                        <div className="col-xs-12">
                            <div className={"alert alert-" + this.state.message.type}>
                                {this.state.message.text}
                            </div>
                        </div>
                    </div>
                    : null}

                <div className="row" style={{ marginBottom: 20 }}>

                </div>

                <div className="row">
                    <div className="col-xs-12 col-sm-4">
                        <div className="form-group">
                            <label className="control-label">
                                Sender Contact ID:
                            </label>

                            <input type="text" className="form-control" name="SenderContactId" value="Member Services" placeholder="Member Services" />
                        </div>
                    </div>

                    <div id="StyleVariablesContainer" className="col-xs-12 col-sm-4 col-lg-4">
                        <div className="form-group">
                            <label className="control-label">Supported Style Variables:</label>
                            <ul className="list-group short-scroll-list">
                                {this.props.styleVariableKeys.map((styleVariable, index) =>
                                    <li key={index} className="list-group-item list-style" style={{ paddingLeft: 7, paddingRight: 0, paddingTop: 7, paddingBottom: 7 }}>{styleVariable}</li>
                                )}
                            </ul>
                        </div>
                    </div>

                    <div className="col-xs-12 col-lg-4" style={{ textAlign: "center" }}>
                        <button className="btn btn-primary" style={{ marginBottom: 5, width: 195 }} value="save" onClick={this.saveTemplate}>Save Changes To Template</button><br />
                        <button className="btn btn-default btn-sm" style={{ marginBottom: 5, width: 195 }} value="save-preview" onClick={this.saveTemplate}>Save & Preview</button><br />
                        <button className="btn btn-default btn-sm" style={{ width: 195 }} onClick={this.cancel}>Cancel & Return to the List</button>
                    </div>


                </div>

                <div className="row">
                    <div className="col-xs-12 col-sm-4">
                        <div className="form-group">
                            <label className="control-label" htmlFor="emailModelSelector">Email Model</label>
                            <select id="emailModelSelector" value={this.state.selectedEmailModelId} className="form-control" onChange={this.emailModelChange}>
                                <option value="0">- select -</option>
                                {this.props.emailModels.list.map((model, index) =>
                                    <option key={index} value={model.id}>{model.description}</option>
                                )};
                            </select>
                        </div>
                    </div>

                    <div id="TemplateVariablesContainer" className="col-xs-12 col-sm-4 col-lg-4">
                        <div className="form-group">
                            <label className="control-label">Supported Model Variables:</label>
                            <ul className="list-group scroll-list">
                                {this.props.modelVariables.map((modelVariable, index) =>
                                    <li key={index} className="list-group-item list-style" style={{ paddingLeft: 7, paddingRight: 0, paddingTop: 7, paddingBottom: 7 }}>{modelVariable}</li>
                                )}
                            </ul>
                        </div>
                    </div>
                </div>


                <div className="row">
                    <div className="col-xs-12">
                        <div className="form-group">
                            <label className="control-label" htmlFor="subjectContainer">Email Subject:</label>
                            <input type="text" className="form-control" placeholder="Subject" value={this.state.subject} onChange={this.subjectChange}></input>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-xs-12">
                        <div className="form-group">
                            <label className="control-label" htmlFor="bodyContainer">Email Body:</label>
                            <textarea className="form-control" placeholder="Html Body" rows={20} value={this.state.body} onChange={this.bodyChange}></textarea>
                        </div>
                    </div>
                </div>

                <div className="h4">Email Tags...</div>

                <div className="row" style={{ marginLeft: 5 }}>
                    <div className="col-xs-12">
                        <div className="row">
                            <div className="col-xs-12 col-sm-3">
                                <label className="control-label" htmlFor="emailFamilySelector">
                                    Email Family
                                </label>
                            </div>
                            <div className="col-xs-12 col-sm-3">
                                <label className="control-label" htmlFor="emailTypeSelector">
                                    Email Type
                                </label>
                            </div>
                            <div className="col-xs-12 col-sm-4">
                                <label className="control-label" htmlFor="excelIdSelector">
                                    Email ID
                                </label>
                            </div>
                        </div>
                    </div>
                </div>

                <div>
                    <div className="row" style={{ marginLeft: 5 }}>
                        {this.state.selectedEmailTemplate.emailTags.map((emailTag, index) =>
                            <div key={index} className="col-xs-12">
                                <div className="row email-family" style={{ marginBottom: 5 }}>
                                    <div className="col-xs-12 col-sm-3">
                                        <div className="form-control">
                                            {emailTag.emailFamily != null ? emailTag.emailFamily.name : ""}
                                        </div>
                                    </div>
                                    <div className="col-xs-12 col-sm-3">
                                        <div className="form-control">
                                            {emailTag.emailType != null ? emailTag.emailType.name : ""}
                                        </div>
                                    </div>
                                    <div className="col-xs-12 col-sm-3">
                                        <div className="form-control">
                                            {emailTag.emailExcelId != null ? emailTag.emailExcelId.name : "N/A"}
                                        </div>
                                    </div>
                                    <div className="col-xs-12 col-sm-2">
                                        <button className="btn btn-danger" value={emailTag.id} onClick={this.deleteEmailTag} >
                                            Delete
                                        </button>
                                    </div>
                                    <br></br>
                                </div>
                            </div>
                        )}
                    </div>

                    <div className="row" style={{ marginLeft: 5, marginBottom: 5 }}>
                        <div className="col-xs-12">
                            <div className="row" style={{ marginBottom: 5 }}>
                                <div className="col-xs-12 col-sm-3">
                                    <select value={this.state.selectedEmailFamilyId} className="form-control" onChange={this.emailFamilyChange}>
                                        <option value="-1">- select -</option>
                                        {this.props.emailFamilies.list.map((family, index) =>
                                            <option key={index} value={family.id}>{family.name}</option>
                                        )};
                                    </select>
                                </div>
                                <div className="col-xs-12 col-sm-3">
                                    <select value={this.state.selectedEmailTypeId} className="form-control" onChange={this.emailTypeChange}>
                                        <option value="-1">- select -</option>
                                        {emailTypes.map((template, index) =>
                                            <option key={index} value={template.id}>{template.name}</option>
                                        )};
                                    </select>
                                </div>
                                <div className="col-xs-12 col-sm-3">
                                    <select value={this.state.selectedEmailExcelId} className="form-control" onChange={this.emailExcelIdChange}>
                                        <option value="-1">- select -</option>
                                        {emailExcelIds.map((emailExcelId, index) =>
                                            <option key={index} value={emailExcelId.id}>{emailExcelId.name}</option>
                                        )};
                                    </select>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-xs-12">
                                    <button className="btn btn-success" onClick={this.addEmailTag} >
                                        Add Email Entity
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="h4" style={{ marginTop: 20, marginBottom: 10 }}>Email Sendees...</div>

                <div className="row">
                    <div className="col-xs-12">
                        <div className="col-xs-12 col-sm-2">
                            <label className="control-label" htmlFor="emailAddressFieldSelector">
                                Field
                            </label>
                        </div>
                        <div className="col-xs-12 col-sm-2">
                            <label className="control-label" htmlFor="contactEntityTypeSelector">
                                Type
                            </label>
                        </div>
                        <div className="col-xs-12 col-sm-2">
                            <label className="control-label" htmlFor="centerTypeSelector">
                                Center
                            </label>
                        </div>
                        <div className="col-xs-12 col-sm-4">
                            <label className="control-label" htmlFor="contactPositionIdSelector">
                                Position
                            </label>
                        </div>
                    </div>
                </div>

                <div>
                    <div className="row" style={{ marginLeft: 5 }}>
                        {this.state.selectedEmailTemplate.emailSendees.map((emailSendee, index) =>
                            <div key={index} className="col-xs-12">
                                <div className="row email-sendee" style={{ marginBottom: 5 }}>
                                    <div className="col-xs-12 col-sm-2">
                                        <div className="form-control">
                                            {emailSendee.emailAddressFieldString}
                                        </div>
                                    </div>
                                    <div className="col-xs-12 col-sm-2">
                                        <div className="form-control">
                                            {emailSendee.contactEntityTypeString}
                                        </div>
                                    </div>
                                    <div className="col-xs-12 col-sm-2">
                                        <div className="form-control">
                                            {emailSendee.centerTypeString}
                                        </div>
                                    </div>
                                    <div className="col-xs-12 col-sm-4">
                                        <div className="form-control">
                                            {emailSendee.contactPositionIdString}
                                        </div>
                                    </div>
                                    <div className="col-xs-12 col-sm-2">
                                        <button className="btn btn-danger" onClick={this.deleteSendee} value={emailSendee.id} >
                                            Delete
                                        </button>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>

                    <div className="row" style={{ marginLeft: 5 }}>
                        <div className="col-xs-12">
                            <div className="row" style={{ marginBottom: 5 }}>
                                <div className="col-xs-12 col-sm-2">
                                    <select value={this.state.selectedEmailAddressFieldId} className="form-control" onChange={this.emailAddressFieldChange}>
                                        <option value="-1">- select -</option>
                                        {this.props.sendeeList.emailAddressFields.map((emailAddressField, index) =>
                                            <option key={index} value={emailAddressField.emailAddressFieldId}>{emailAddressField.description}</option>
                                        )};
                                    </select>
                                </div>

                                <div className="col-xs-12 col-sm-2">
                                    <select value={this.state.selectedContactEntityTypeId} className="form-control" onChange={this.contactEntityChange}>
                                        <option value="-1">- select -</option>
                                        {this.props.sendeeList.contactEntityTypes.map((contactEntityType, index) =>
                                            <option key={index} value={contactEntityType.entityTypeId}>{contactEntityType.entityTypeDescription}</option>
                                        )};
                                    </select>
                                </div>

                                <div className="col-xs-12 col-sm-2">
                                    <select value={this.state.selectedCenterTypeId} className="form-control" onChange={this.centerTypeChange}>
                                        <option value="-1">{centerTypes.length > 0 ? "- select -" : "N/A"}</option>
                                        {centerTypes.map((centerType, index) =>
                                            <option key={index} value={centerType.centerTypeId}>{centerType.description}</option>
                                        )};
                                    </select>
                                </div>

                                <div className="col-xs-12 col-sm-4">
                                    <select value={this.state.selectedContactPositionId} className="form-control" onChange={this.contactPositionChange}>
                                        <option value="-1">- select -</option>
                                        {contactPositions.map((contactPosition, index) =>
                                            <option key={index} value={contactPosition.contactPositionId}>{contactPosition.description}</option>
                                        )};
                                    </select>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-xs-12">
                                    <button className="btn btn-success" onClick={this.addSendee} >
                                        Add Sendee
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row" style={{ marginTop: 20, marginBottom: 10 }}>
                    <div className="col-xs-12">
                        <label htmlFor="sendEmailToEntity">
                            <div style={{ display: "flex", alignItems: "center" }}>
                                <div><input type="checkbox" id="sendEmailToEntity" style={{ marginRight: 5 }} checked={this.state.sendToEntity} onChange={this.sendToEntityChange} /></div>
                                <div>Send email to main entity (e.g. the donor)</div>
                            </div>
                        </label>
                    </div>
                </div>

                <div className="row" style={{ marginTop: 20, marginBottom: 10 }}>
                    <div className="col-xs-12 col-lg-12" style={{ display: "flex", justifyContent: "center" }}>
                        <button className="btn btn-primary" style={{ marginRight: 5, width: 195 }} value="save" onClick={this.saveTemplate}>Save Changes To Template</button>
                        <button className="btn btn-default btn-sm" style={{ marginRight: 5, width: 195 }} value="save-preview" onClick={this.saveTemplate}>Save & Preview</button>
                        <button className="btn btn-default btn-sm" style={{ width: 195 }} onClick={this.cancel}>Cancel & Return to the List</button>
                    </div>
                </div>

                <Modal bsSize="lg" show={this.state.showAddSendeeWarning} onHide={this.entityModalOnHide}>
                    <Modal.Header>
                        <Modal.Title>Validation</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        Please select the email family, email type, and Excel ID
                    </Modal.Body>
                    <Modal.Footer >
                        <button className="btn btn-primary" onClick={this.hideEntityModel}>Ok</button>
                    </Modal.Footer>
                </Modal>
            </div>
        )
    }
}

const mapAppStateToProps = (appState: IApplicationState): IEmailTemplateEditStateProps => {
    return {
        emailFamilies: appState.emailFamilies,
        emailTemplates: appState.emailTemplates,
        emailModels: appState.emailModels,
        styleVariableKeys: appState.emailModels.emailEngineVariableKeys,
        modelVariables: appState.emailModels.emailModelTemplateVariables,
        sendeeList: appState.emailTemplates.sendeeList,
        emailTags: appState.emailTemplates.emailTags
    };
};

const mapDisptachToProps = (dispatch: Dispatch<IApplicationState>): IEmailTemplateDispatchProps => {
    return {
        showLoading: (message) => { return dispatch(AppActionCreators.showLoadingAsync(message)); },
        hideLoading: () => { dispatch(AppActionCreators.hideLoading()); },
        getEmailTemplate: (templateId) => { return dispatch(EmailTemplateActionCreators.getEmailTemplate(templateId)); },
        getEmailModelTemplateVariables: (emailModelId) => { return dispatch(EmailModelActionCreators.getEmailModelTemplateVariables(emailModelId)); },
        getEmailEngineVariableKeys: () => { return dispatch(EmailModelActionCreators.getEmailEngineVariableKeys()); },
        getEmailModel: () => { return dispatch(EmailModelActionCreators.getEmailModel()); },
        getSendeeList: () => { return dispatch(EmailTemplateActionCreators.getSendeeList()); },
        getEmailFamilyList: () => { return dispatch(EmailFamilyActionCreators.getEmailFamily()); },
        addSendee: (emailTemplateId, emailAddressFieldId, centerTypeId, contactEntityTypeId, contactPositionId) => {
            return dispatch(EmailTemplateActionCreators.addSendee(emailTemplateId, emailAddressFieldId, centerTypeId, contactEntityTypeId, contactPositionId));
        },
        deleteSendee: (emailSendeeId) => { return dispatch(EmailTemplateActionCreators.deleteSendee(emailSendeeId)); },
        addEmailTag: (emailTemplateId, emailFamilyId, emailTypeId, emailExcelId) => { return dispatch(EmailTemplateActionCreators.addEmailTag(emailTemplateId, emailFamilyId, emailTypeId, emailExcelId)); },
        deleteEmailTag: (emailId) => { return dispatch(EmailTemplateActionCreators.deleteEmailTag(emailId)); },
        saveEmailTemplate: (emailTemplateId, emailModelId, subject, body, sendToEntity) => { return dispatch(EmailTemplateActionCreators.saveEmailTemplate(emailTemplateId, emailModelId, subject, body, sendToEntity)); }
    };
};

export default withRouter(connect<IEmailTemplateEditStateProps, IEmailTemplateDispatchProps, IOwnProps>(
    mapAppStateToProps,
    mapDisptachToProps)(EmailTemplateEdit));